import WishlistCount from './product-details/wishlist-count';
import CommentsCounter from './ugc-get/comments-counter';
import StarRate from './ugc-get/star-rate';
const ProductStats = () => {
  return <div className='mb-4 flex w-[316px] divide-x divide-x-reverse divide-border-gray-light whitespace-nowrap lg:mb-0 lg:justify-between lg:self-end [&>*:first-child]:pr-0 [&>*:last-child]:ml-auto [&>*]:px-2 [&>*]:lg:px-1.5' data-sentry-component="ProductStats" data-sentry-source-file="product-stats.tsx">
            <StarRate isLinkToCommentSection data-sentry-element="StarRate" data-sentry-source-file="product-stats.tsx" />
            <CommentsCounter isLinkToCommentSection data-sentry-element="CommentsCounter" data-sentry-source-file="product-stats.tsx" />
            <WishlistCount data-sentry-element="WishlistCount" data-sentry-source-file="product-stats.tsx" />
        </div>;
};
export default ProductStats;